import CitySEOHead from "@/components/feature/CitySEOHead";
import LakeCharlesHeroSection from "./components/HeroSection";
import LakeCharlesStickyNav from "./components/StickyNav";
import LakeCharlesProcessingTimeSection from "./components/ProcessingTimeSection";
import LakeCharlesServicesSection from "./components/ServicesSection";
import LakeCharlesLocalAreaSection from "./components/LocalAreaSection";
import LakeCharlesTravelTimingSection from "./components/TravelTimingSection";
import LakeCharlesDestinationsSection from "./components/DestinationsSection";
import LakeCharlesTestimonialsSection from "./components/TestimonialsSection";
import LakeCharlesAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import LakeCharlesComparisonSection from "./components/ComparisonSection";
import LakeCharlesMistakesSection from "./components/MistakesSection";
import LakeCharlesHowItWorksSection from "./components/HowItWorksSection";
import LakeCharlesFAQSection, { faqs } from "./components/FAQSection";
import LakeCharlesHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import LakeCharlesFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function LakeCharlesPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Lake Charles"
        state="Louisiana"
        stateAbbr="LA"
        route="/cities/lake-charles"
        title="Emergency Passport Lake Charles, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Lake Charles, LA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving petrochemical engineers, casino professionals, McNeese students, and Southwest Louisiana families."
        geoPlacename="Lake Charles, Louisiana"
        geoPosition="30.2266;-93.2174"
        faqs={faqs}
        servicesSchema={[
          { name: "Emergency Passport", description: "Urgent passport processing for Lake Charles travelers with immediate departure needs — as fast as 24 hours for Southwest Louisiana residents." },
          { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Lake Charles with an expired or expiring passport." },
          { name: "New Passport", description: "First-time passport application assistance for McNeese students and Lake Charles families." },
          { name: "Lost or Stolen Passport", description: "Passport replacement for lost or stolen passports with DS-64 form guidance in Lake Charles, LA." },
          { name: "Child Passport", description: "Passport services for minors under 16 with parental consent guidance for Southwest Louisiana families." },
          { name: "Name Change", description: "Passport correction and name change service for Lake Charles residents after marriage or legal changes." },
          { name: "Second Passport", description: "Second passport service for petrochemical engineers and casino professionals from Lake Charles." },
        ]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <LakeCharlesHeroSection />
      <LakeCharlesStickyNav />
      <LakeCharlesProcessingTimeSection />
      <LakeCharlesLocalAreaSection />
      <LakeCharlesServicesSection />
      <LakeCharlesTravelTimingSection />
      <LakeCharlesDestinationsSection />
      <LakeCharlesTestimonialsSection />
      <LakeCharlesAcceptanceFacilitiesSection />
      <LakeCharlesComparisonSection />
      <LakeCharlesMistakesSection />
      <LakeCharlesHowItWorksSection />
      <LakeCharlesFAQSection />
      <LakeCharlesHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/lake-charles" state="LA" />
      <LakeCharlesFinalCTA />
    </div>
  );
}